// extracted by mini-css-extract-plugin
export default {"contentWrapper":"style_contentWrapper__QZF0F","button":"style_button__Q1vib","info":"style_info__xN9yu","cardHeader":"style_cardHeader__qsMn1","cardTitle":"style_cardTitle__ES3qW"};